import Rx from 'rxjs/Rx';

export default class AuthService {
  constructor($window, $http, host) {
    this.$window = $window;
    this.http = $http;
    this.host = host;
  }

  login(email, password) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/sessions',
      data: {
        email: email, password: password,
        fields: ['invitations', 'profiles']
      }
    }));
  }

  logout() {
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: this.host + '/api/sessions',
      data: {}
    }).then(
      (resp) => {
        this.$window.localStorage.removeItem('jwtToken');
        this.$window.localStorage.removeItem('accToken');
        this.$window.localStorage.removeItem('currentProfile');
        this.$window.localStorage.removeItem('google_state');
        this.$window.localStorage.removeItem('profilesCount');
        this.$window.localStorage.removeItem('__paypal_storage__');
        this.$window.localStorage.removeItem('userlanguage');
      },
      (resp) => {}
    ));
  }

  saveToken(token) {
    this.$window.localStorage.jwtToken = token;
  }

  getToken() {
    return this.$window.localStorage.jwtToken;
  }

  saveAccountToken(token) {
    this.$window.localStorage.accToken = token;
  }

  getAccountToken() {
    return this.$window.localStorage.accToken;
  }

  removeAccountToken() {
    this.$window.localStorage.removeItem('accToken');
  }

  parseJwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(this.$window.atob(base64));
  }

  isAuthenticated() {
    var token = this.getToken();
    if (token) {
      let params = this.parseJwt(token);
      return Math.round(new Date().getTime() / 1000) <= params.exp;
    }
    return false;
  }
  
  hasAccount() {
    let token = this.getAccountToken()
    if (token){
      let params = this.parseJwt(token);
      return Math.round(new Date().getTime() / 1000) <= params.exp;
    }
    return false;
  }

  getAccountRole(){
    return this.parseJwt(this.getAccountToken()).role;
  }

  getProfile(){
    return JSON.parse(this.$window.localStorage.currentProfile);
  }

  getLanguage() {
    return this.parseJwt(this.getToken()).user_claims.language;
  }
}

 AuthService.$inject = ['$window', '$http', 'host'];



// WEBPACK FOOTER //
// ./src/app/services/auth.service.js